import { FC } from 'react'

import { format } from 'date-fns'

import { MatchStatus } from '@sportworld/js-sdk/src/types/soccerDataTypes'

import i18n from '@/i18n'
import {
  dateRelativeTranslation,
  dateTranslation,
} from '@/i18n/dateTranslation'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { MATCHES_COLUMNS } from '../config'
import { focusIds } from '../constants'
import { renderMatchScore, renderTeamCell } from '../partials'
import {
  Column,
  DateContainer,
  LabelLive,
  TableRowWrapper,
  Time,
  TimeDescription,
  TimeLabel,
  TimeWrapper,
} from '../styles'
import { MatchProps } from '../types'

const columns = MATCHES_COLUMNS

export const Match: FC<MatchProps> = ({ match, onClick, isCommentaryTab }) => {
  const { t } = useCommonTranslation()

  const isLive = match.matchStatus === MatchStatus.Playing
  const date = new Date(match.startsAt)
  const isUSLocale = i18n.language.includes('US')

  const renderTimeDescription = () => (
    <TimeDescription>
      <DateContainer>
        {dateTranslation(date, 'eeee, do MMMM yyyy')}
      </DateContainer>
      <TimeWrapper>
        <Time>{format(date, isUSLocale ? 'h:mma' : 'HH:mm')}</Time>
        {isLive && <LabelLive>{t('live')}</LabelLive>}
      </TimeWrapper>
    </TimeDescription>
  )

  const renderTimeLabel = () => {
    const time = format(date, isUSLocale ? 'hh:mm a' : 'HH:mm')
    const dateFormat = isUSLocale ? `eeeeee, MM/dd` : `eeeeee, dd.MM`
    const relativeDate = dateRelativeTranslation(date, dateFormat)
    const formattedDate = `${relativeDate} - ${time}`
    const label = isLive ? t('live') : formattedDate
    return (
      <TimeWrapper>
        <TimeLabel $isLive={isLive}>{label}</TimeLabel>
      </TimeWrapper>
    )
  }
  const focusIdPrefix = isCommentaryTab
    ? focusIds.matchCommentary
    : focusIds.match
  const tableRowFocusId = focusIdPrefix + match.id

  return (
    <TableRowWrapper
      onSelected={() => onClick?.(match)}
      id={tableRowFocusId}
      focusId={tableRowFocusId}
      $tall
    >
      <Column $width={columns[0].width}>
        {renderTeamCell(match.home, true)}
      </Column>
      <Column $width={columns[1].width} $accent={isLive}>
        {renderMatchScore(match)}
      </Column>
      <Column $width={columns[2].width}>
        {renderTeamCell(match.away, false)}
      </Column>
      {isCommentaryTab ? renderTimeLabel() : renderTimeDescription()}
    </TableRowWrapper>
  )
}
